import MunicipalitiesService from 'js/services/api/topology/municipalities'

// Datos del municipio a utilizar en la aplicación
function municipalityRepresentation(municipality) {
  return {
    ...municipality,
    country_alpha2: municipality.country_alpha2.toLowerCase(),
    distance: undefined // Se calcula a posteriori en la vista home con el propósito de ordenar
  }
}

export default ({
  namespaced: true,

  state: {
    // Listado de municipios disponibles en la plataforma
    availables: [],
    municipality: null
  },

  mutations: {
    setAvailableMunicipalities(state, availables) {
      state.availables = availables
    },

    setMunicipality(state, municipality) {
      state.municipality = municipality
    }
  },

  getters: {
    currentMunicipality(state) {
      return state.municipality || {}
    },

    availableMunicipalities(state) {
      return state.availables
    },

    // Comprueba si se puede seleccionar municipios (si hay más de uno)
    canSelectMunicipality(state) {
      return (state.availables?.length || 0) > 1
    },

    // Comprueba si no se han cargado los municipios
    noMunicipalityLoaded(state) {
      return (state.availables?.length || 0) <= 0
    },

    // Comprueba si no se han cargado los municipios
    municipalityLoaded(state, getters) {
      return !getters.noMunicipalityLoaded
    },

    // Comprueba si no se ha seleccionado un municipios
    noMunicipalitySelected(state) {
      return state.municipality === null || state.municipality === undefined
    },

    // Ruta de página home
    homeRoute(state, getters) {
      if (getters.canSelectMunicipality) {
        return {name: 'home'}
      }

      return {
        name: HOME_ROUTE,
        params: {
          country: getters.country,
          municipality: getters.municipality
        }
      }
    },

    // Primer municipio disponible
    firstAvailableMunicipality(state) {
      return state.availables?.[0] || null
    },

    firstHighlightedMunicipality(state) {
      return state.availables.find(municipality => municipality.highlighted) || null
    },

    firstMunicipalityByName(state) {
      return name => state.availables.find(municipality => municipality.name_normalized === name) || null
    },

    country(state) {
      return state.municipality?.country_alpha2 || null
    },

    municipality(state) {
      return state.municipality?.name_normalized || null
    },

    image(state, getters) {
      return getters.currentMunicipality?.image_url || null
    },

    description(state, getters) {
      return getters.currentMunicipality?.description_for_client || null
    },

    highlighted(state, getters) {
      return getters.currentMunicipality?.highlighted || null
    },

    nameNormalized(state, getters) {
      return getters.currentMunicipality?.name_normalized || null
    },

    hasSingleMunicipality(state, getters){
      return (getters.availableMunicipalities).length === 1
    }
  },

  actions: {
    async loadAvailableMunicipalities({state, getters, commit, dispatch}, options) {
      // devDump("Attempting to get the municipios from the API")
      const params = {template: 'with_counters'}
      const response = await MunicipalitiesService.index(params)
      const municipalities = _.map(response.data, municipalityRepresentation)
      
      commit('setAvailableMunicipalities', municipalities)

      /** If only 1 municipality available we'll load it directly */
      if(getters.hasSingleMunicipality) {
        const firstMun = getters.firstAvailableMunicipality
        if(_.isEmpty(firstMun)) return

        commit('setMunicipality', firstMun)
        dispatch('getOperators', null, { root: true })
      }

      if(!getters.noMunicipalitySelected || _.isEmpty(municipalities)) return
      
      /** If not municipality is selected and there are available municipalities, it'll load by the url or the highlighted one */
      if(options?.routeMunicipalityName) {
        const municipalityByName = getters.firstMunicipalityByName(options.routeMunicipalityName)
        if(municipalityByName) {
          commit('setMunicipality', municipalityByName)
          dispatch('getOperators', null, { root: true })
          return
        }
      }

      const lastLoadedId = sessionStorage.getItem('municipality-id') || null
      if(lastLoadedId) {
        const municipality = state.availables.find(i => i.id = lastLoadedId)
        if(municipality) {
          commit('setMunicipality', municipality)
          dispatch('getOperators', null, { root: true })
          return
        }
      }

      const firstHighlighted = getters.firstHighlightedMunicipality
      if(firstHighlighted) {
        commit('setMunicipality', firstHighlighted)
        dispatch('getOperators', null, { root: true })
      }
    },

    async loadMunicipality({commit}, {municipalityName}) {
      const municipality = await MunicipalitiesService.showSlug(municipalityName)
      commit('setMunicipality', municipality)
    },

    selectMunicipality({commit, state}, data) {
      
      const countryAlpha2 = data.countryAlpha2
      const municipalityName = data.municipalityName

      const municipality = state.availables.find(mun => {
        mun.country_alpha2 === countryAlpha2.toLowerCase() 
        && mun.name_normalized === municipalityName.toLowerCase()
      })
      commit('setMunicipality', municipality)
      
    }
  }
})
